import CustomCheckbox from "../../CustomCheckbox";
import messageResource from "../../messageResource";

export default class ShowDisabledCheckbox extends CustomCheckbox
{
    constructor(messageKey)
    {
        super();
        this.messageKey = messageKey;
    }

    templateHtml()
    {
        return "<div class='showDisabledCheckbox'>" +
               "  <div class='labelWrapper'>" +
               "    <span class='label'></span>" +
               "  </div>" +
               "</div>"
    }

    useUnderscoreTemplate()
    {
        return false;
    }

    afterRender()
    {
        super.afterRender();

        if (this.showLater)
            this.show();
        else if (this.hideLater)
            this.hide();

        this.$label = this.find(".label");
        disableTextSelection(this.$label[0], true);
    }

    update()
    {
        if (this.rendered)
        {
            super.update();
            const showOrHide = messageResource.getMessage(this.checked ? "common.hide" : "common.show");
            this.$label.html(messageResource.getEscapedMessage(this.messageKey, [showOrHide]));
        }
    }

    show()
    {
        if (this.rendered)
        {
            super.show();
        }
        else
        {
            this.showLater = true;
            this.hideLater = false;
        }
    }

    hide()
    {
        if (this.rendered)
        {
            super.hide();
        }
        else
        {
            this.hideLater = true;
            this.showLater = false;
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/ShowDisabledCheckbox.js